/**
 * Veliye gönderilmiş rapor.
 *
 * İçerik ÜRETİM ANINDA dondurulmuş bir jsonb; burada yeniden
 * hesaplanmıyor. Sebebi: veli "geçen ayki raporda şu yazıyordu" dediğinde
 * o metnin değişmemiş olması gerekir. Rapor üreticisi henüz yazılmadı;
 * bu ekran aşağıdaki biçimi bekliyor ve tanımadığı bir içerikle
 * karşılaşırsa uydurmak yerine durumu söylüyor.
 *
 *   { surum: "1", ozet: string,
 *     bolumler: [{ baslik: string, metin: string }],
 *     kisitlar: string }
 */

import { useEffect, useState } from 'react'
import { api, type RaporTam } from '../api'

interface Bolum {
  baslik?: unknown
  metin?: unknown
}

function gun(s: string): string {
  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('tr-TR', { dateStyle: 'medium' })
}

export function Rapor({ raporId, onGeri }: { raporId: string; onGeri: () => void }) {
  const [rapor, setRapor] = useState<RaporTam | null>(null)
  const [hata, setHata] = useState<string | null>(null)

  useEffect(() => {
    let iptal = false
    api
      .rapor(raporId)
      .then((r) => {
        if (!iptal) setRapor(r.rapor)
      })
      .catch(() => {
        if (!iptal) setHata('Rapor açılamadı.')
      })
    return () => {
      iptal = true
    }
  }, [raporId])

  if (hata) {
    return (
      <>
        <div className="uyari">{hata}</div>
        <button onClick={onGeri}>← Geri</button>
      </>
    )
  }
  if (!rapor) return <p className="alt">Yükleniyor…</p>

  const icerik = rapor.icerik ?? {}
  const ozet = typeof icerik['ozet'] === 'string' ? (icerik['ozet'] as string) : null
  const bolumler = Array.isArray(icerik['bolumler']) ? (icerik['bolumler'] as Bolum[]) : []
  const kisitlar = typeof icerik['kisitlar'] === 'string' ? (icerik['kisitlar'] as string) : null
  const okunabilir = Boolean(ozet || bolumler.length > 0)

  return (
    <>
      <div className="dugmeler" style={{ marginBottom: 12 }}>
        <button onClick={onGeri}>← Geri</button>
        <button onClick={() => window.print()}>Yazdır</button>
      </div>

      <h1>Gelişim raporu</h1>
      <p className="alt">
        {gun(rapor.donemBas)} – {gun(rapor.donemBit)} · gönderildiği gün {gun(rapor.gonderildi)}
      </p>

      {!okunabilir ? (
        <div className="uyari">
          Bu raporun içeriği bu sürümde görüntülenemiyor. Merkezden çıktısını isteyebilirsiniz.
        </div>
      ) : (
        <>
          {ozet && (
            <div className="alan">
              <div className="alan-yorum">{ozet}</div>
            </div>
          )}
          {bolumler.map((b, i) => (
            <section className="alan" key={i}>
              {typeof b.baslik === 'string' && <div className="alan-ad">{b.baslik}</div>}
              {typeof b.metin === 'string' && <div className="alan-yorum">{b.metin}</div>}
            </section>
          ))}
        </>
      )}

      {kisitlar && <div className="kisit">{kisitlar}</div>}

      <p className="alt" style={{ marginTop: 16 }}>
        Rapordaki bir şeyi anlamadıysanız ya da katılmıyorsanız, uygulayıcınızla konuşun.
        Bu metin bir tanı değildir.
      </p>
    </>
  )
}
